<template>
  <v-container fluid>
    <section class="content-header">
      <v-toolbar dense dark color="#96298A">
        <v-toolbar-title>Guías Aéreas</v-toolbar-title
        ><v-divider class="mx-4" vertical />
        <v-text-field
          v-model="searcher"
          label="Buscar"
          single-line
          hide-details
          clearable
          max-width="200px"
          @keyup.enter="getData()"
          @input="handleChangeSearch()"
        />
        <v-tooltip bottom color="#96298A">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              ref="getData"
              icon
              @click="getData()"
              x-large
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> mdi-file-find </v-icon>
            </v-btn>
          </template>
          <span>Buscar</span>
        </v-tooltip>
        <v-spacer />
        <v-toolbar-items>
          <v-divider vertical></v-divider>
          <v-tooltip bottom color="#96298A">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon large v-bind="attrs" v-on="on" @click="crearGuia('E')">
                <v-icon>mdi-airplane</v-icon>
              </v-btn>
            </template>
            <span>Crear Exportación</span>
          </v-tooltip>
          <v-divider vertical></v-divider>
          <v-tooltip bottom color="#96298A">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon large v-bind="attrs" v-on="on" @click="crearGuia('I')">
                <v-icon>mdi-airplane mdi-rotate-90</v-icon>
              </v-btn>
            </template>
            <span>Crear Importación</span>
          </v-tooltip>
          <v-divider vertical></v-divider>
          <v-tooltip bottom color="#96298A">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon large v-bind="attrs" v-on="on" @click="crearGuia('N')">
                <v-icon>mdi-truck-check</v-icon>
              </v-btn>
            </template>
            <span>Crear Nacional</span>
          </v-tooltip>
          <v-divider vertical></v-divider>
          <v-tooltip bottom color="#96298A">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon large @click="getData()" v-bind="attrs" v-on="on">
                <v-icon>mdi-table-refresh</v-icon>
              </v-btn>
            </template>
            <span>Actualizar Tabla</span>
          </v-tooltip>
          <v-divider class="mx-4" vertical />
          <v-combobox
            v-model="tipo"
            label="Tipo"
            :items="filtro"
            append-icon="filter"
            item-value="cod"
            item-text="tipo"
            return-object
            clearable
          />
        </v-toolbar-items>
      </v-toolbar>
    </section>
    <v-row>
      <v-col>
        <v-data-table
          :headers="isCliente == 0 ? headers : headersCli"
          :items="guiasF"
          class="elevation-1"
          :options.sync="options"
          :server-items-length="totalData"
        >
            <!-- This template looks for headers with formatters and executes them -->
            <template
              v-for="header in headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ header, value }"
            >
              {{ header.formatter(value) }}
            </template>
          <template v-slot:item.acciones="{ item }">
            <v-btn icon color="info" @click="edtGuia(item)" v-if="Boolean(item.finalizado) == false && item.proveedor == null">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon color="red" @click="deleteItem(item)" v-if="Boolean(item.finalizado) == false && item.proveedor == null">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="gray" icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-format-list-bulleted-type</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  link
                  dense
                  @click="showModalVistaGuia(item)"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-file-search</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Ver Guía</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  dense
                  @click="duplicarGuia(item)"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-content-duplicate</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Duplicar Guía</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  dense
                  @click="showModalPrintGuia(item)"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-printer</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Imprimir Guía Interna</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-if="item.factura == 'Crear'"
                  link
                  dense
                  @click="showModalPrintF(item)"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-printer</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Imprimir Factura</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  dense
                  @click="showModalAddCliente(item)"
                  v-if="isCliente == 0"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-handshake</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Asignar Cliente</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item link dense @click="showModalEstatus(item)" v-if="isCliente == 0">
                  <v-list-item-icon>
                    <v-icon>mdi-tag-plus</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Agregar Estatus</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  dense
                  @click="showModalPickNacional(item)"
                  v-if="item.tipoguia != 'importacion' && item.recolecta == 0"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-truck-fast</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      >Solicitar PickUp Nacional</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  dense
                  @click="showModalEnvDHL(item)"
                  v-if="item.proveedor == null && item.tipoguia != 'nacional' && isCliente == 0"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-truck-delivery</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Enviar a DHL</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  dense
                  @click="descargarLabelsDHL(item)"
                  v-if="item.proveedor == 'DHL' && isCliente == 0"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-file</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      >Labels DHL (Vista Previa)</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  dense
                  @click="descargarLabelsDHL(item, true)"
                  v-if="item.proveedor == 'DHL' && isCliente == 0"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-cloud-download</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      >Labels DHL (Descargar)</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  dense
                  @click="descargarFacturaDHL(item)"
                  v-if="item.proveedor == 'DHL' && item.facturadhl == 1 && isCliente"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-file</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      >Factura DHL (Vista Previa)</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  dense
                  @click="descargarFacturaDHL(item, true)"
                  v-if="item.proveedor == 'DHL' && item.facturadhl == 1 && isCliente == 0"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-cloud-download</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      >Factura DHL (Descargar)</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-if="item.proveedor == 'DHL' && isCliente == 0"
                  link
                  dense
                  @click="showModalPrintReceiptDhl(item)"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-printer</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Imprimir Receipt DHL</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  dense
                  @click="showModalPickDHL(item)"
                  v-if="
                    item.proveedor == 'DHL' &&
                    item.tipoguia == 'importacion' &&
                    item.recolectaprov == 0 &&
                    isCliente == 0
                  "
                >
                  <v-list-item-icon>
                    <v-icon>mdi-truck-fast</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      >Solicitar PickUp a DHL</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  dense
                  @click="showModalEnvUPS(item)"
                  v-if="item.proveedor == null && item.tipoguia != 'nacional' && isCliente == 0"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-truck-delivery</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Enviar a UPS</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  dense
                  @click="descargarLabelsUPS(item)"
                  v-if="item.proveedor == 'UPS' && isCliente == 0"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-folder-zip</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Generar Labels UPS</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  dense
                  @click="showModalPickUPS(item)"
                  v-if="
                    item.proveedor == 'UPS' &&
                    item.tipoguia == 'importacion' &&
                    item.recolectaprov == 0 &&
                    isCliente == 0
                  "
                >
                  <v-list-item-icon>
                    <v-icon>mdi-truck-fast</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      >Solicitar PickUp a UPS</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  dense
                  @click="showModalEnvFedEx(item)"
                  v-if="item.proveedor == null && item.tipoguia != 'nacional' && isCliente == 0"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-truck-delivery</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Enviar a FedEx</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  dense
                  @click="showModalPickFedex(item)"
                  v-if="
                    item.proveedor == 'FedEx' &&
                    item.recolectaprov == 0 &&
                    isCliente == 0
                  "
                >
                  <v-list-item-icon>
                    <v-icon>mdi-truck-fast</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      >Solicitar PickUp a FedEx</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  dense
                  @click="descargarLabelsFedex(item)"
                  v-if="item.proveedor == 'FedEx' && isCliente == 0"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-file</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      >Labels FedEx</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                      link
                      dense
                      @click="showModalEnvTramaco(item)"
                      v-if="isCliente == 0
                      && (item.proveedor == null || item.proveedor == '')
                      && Boolean(item.finalizado) == false
                      "
                    >
                      <v-list-item-icon>
                        <v-icon>mdi-truck-delivery</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Enviar Tramaco</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                <v-list-item
                  link
                  dense
                  @click="imprimirGuiaTramaco(item)"
                  v-if="isCliente == 0 && item.proveedor == 'Tramaco'"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-file-download</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Imprimir Guía Tramaco</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                      link
                      dense
                      @click="showModalEnvServ(item)"
                      v-if="isCliente == 0
                      && (item.proveedor == null || item.proveedor == '')
                      && Boolean(item.finalizado) == false
                      "
                    >
                      <v-list-item-icon>
                        <v-icon>mdi-truck-delivery</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Enviar ServiEntrega</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      link
                      dense
                      @click="imprimirGuiaServiE(item)"
                      v-if="isCliente == 0 && item.proveedor == 'SERVIENTREGA'"
                    >
                      <v-list-item-icon>
                        <v-icon>mdi-file-download</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Imprimir Guía ServiEntrega</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      link
                      dense
                      @click="generarRotulosServiE(item)"
                      v-if="isCliente == 0 && item.proveedor == 'SERVIENTREGA'"
                    >
                      <v-list-item-icon>
                        <v-icon>mdi-file-download</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Generar Rotulos ServiEntrega</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      link
                      dense
                      @click="generarStickersServiE(item)"
                      v-if="isCliente == 0 && item.proveedor == 'SERVIENTREGA'"
                    >
                      <v-list-item-icon>
                        <v-icon>mdi-file-download</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Generar Stickers ServiEntrega</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                <v-list-item
                  link
                  dense
                  @click="showModalAddAgente(item)"
                  v-if="
                    (item.proveedor == null || item.proveedor == '') &&
                    Boolean(item.finalizado) == false &&
                    isCliente == 0
                  "
                >
                  <v-list-item-icon>
                    <v-icon>mdi-truck-check</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Asignar Agente</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-if="item.proveedor != null && Boolean(item.finalizado) == false && isCliente == 0"
                  link
                  dense
                  @click="revertirEnvio(item)"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-backspace</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Revertir Envío Agente</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item link dense @click="showModalImagenPod(item)" v-if="isCliente == 0">
                  <v-list-item-icon>
                    <v-icon>mdi-handshake</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      >Imagenes Prueba de Entrega</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  dense
                  @click="showModalAddUndel(item)"
                  v-if="isCliente == 0"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-briefcase-search</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Asignar UNDEL</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  dense
                  @click="showModalAddSeguro(item)"
                  v-if="isCliente == 0"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-lock</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Asignar Seguro</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  dense
                  @click="showModalAddCargos(item)"
                  v-if="isCliente == 0"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-cash</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Asignar Cargos Adicionales</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  dense
                  @click="showModalAddReclamos(item)"
                  v-if="isCliente == 0"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-flag-remove-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Agregar Reclamos</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  dense
                  @click="showModalAddInfoAdic(item)"
                  v-if="isCliente == 0"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-information</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Asignar Información Adicional</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  dense
                  @click="showModalAddRepesaje(item)"
                  v-if="isCliente == 0"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-scale-balance</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Proceso RPP</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  dense
                  @click="showModalEnvCorreo(item)"
                  v-if="isCliente == 0"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-email</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Enviar Correo</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  dense
                  @click="showModalCotizacion(item)"
                  v-if="item.tipoguia != 'nacional'"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-cash</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Cotizacion</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <!--FORMULARIO MODAL -->
    <v-dialog
      v-model="dlgOpciones"
      :fullscreen="fullScreen"
      width="900"
      transition="dialog-bottom-transition"
      scrollable
      persistent
    >
      <v-card elevation="24" outlined>
        <v-toolbar dark color="#96298A" dense max-height="50">
          <v-toolbar-title>
            Guía Aerea - {{ tipoguia }}
            <span v-if="datos">{{ datos.guia_interna }}</span>
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-divider vertical />
            <v-btn v-if="!fullScreen" icon dark @click="fullScreen = true">
              <v-icon>mdi-window-maximize</v-icon>
            </v-btn>
            <v-btn v-if="fullScreen" icon dark @click="fullScreen = false">
              <v-icon>mdi-window-minimize</v-icon>
            </v-btn>
            <v-divider vertical />
            <v-btn icon dark @click="cerrarModal()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-divider vertical />
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <statusguia
            v-if="dialogSet.nombre == 'estatusGuia'"
            :id="id"
            :finalizado="Boolean(datos.finalizado)"
          />
          <printfactura v-if="dialogSet.nombre == 'printFactura'" :id="id" />
          <printguia v-if="dialogSet.nombre == 'printGuia'" :id="id" />
          <cotizacion v-if="dialogSet.nombre == 'cotizacion'" :id="id" />
          <vistaguia v-if="dialogSet.nombre == 'vistaGuia'" :id="id" />
          <printreceiptdhl
            v-if="dialogSet.nombre == 'printReceiptDhl'"
            :id="id"
          />
          <enviardhl :id="id" v-if="dialogSet.nombre == 'envDHL'" />
          <enviar-fedex :id="id" v-if="dialogSet.nombre == 'envFedEx'" />
          <pickupdhl :id="id" v-if="dialogSet.nombre == 'pickDHL'" />
          <envioups :id="id" v-if="dialogSet.nombre == 'envUPS'" />
          <pickupups :id="id" v-if="dialogSet.nombre == 'pickUPS'" />
          <pickup-fed-ex :id="id" v-if="dialogSet.nombre == 'pickFedEx'" />
          <pickupnacional :id="id" v-if="dialogSet.nombre == 'pickNac'" />
          <agregaragente :id="id" v-if="dialogSet.nombre == 'addAgente'" />
          <asignarcliente :id="id" v-if="dialogSet.nombre == 'addCliente'" />
          <asignarundel :id="id" v-if="dialogSet.nombre == 'addUndel'" />
          <asignarseguro :id="id" v-if="dialogSet.nombre == 'addSeguro'" />
          <asignarcargosadicionales :id="id" v-if="dialogSet.nombre == 'addCargos'" />
          <informacionadicional :id="id" v-if="dialogSet.nombre == 'addInfoAdic'" />
          <reclamos :id="id" v-if="dialogSet.nombre == 'reclamos'" />
          <repesaje :id="id" v-if="dialogSet.nombre == 'repesaje'" />
          <cargarimagenpod :id="id" v-if="dialogSet.nombre == 'imgPOD'" />
          <guia :codtipoguia="codtipoguia" :id="id"  v-if="dialogSet.nombre == 'guia'" />
          <mailtemplate :idGuia="id" v-if="dialogSet.nombre == 'envCorreo'" />
          <EnviarTramaco :mode="'CO'" :id="id" :guias="guiasTransmitir" v-if="dialogSet.nombre == 'envtramaco'"></EnviarTramaco>
          <EnviarServiEntrega :mode="'CO'" :id="id" :guias="guiasTransmitir" v-if="dialogSet.nombre == 'envserv'"></EnviarServiEntrega>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--FORMULARIO MODAL -->
  </v-container>
</template>

<script>
import apicon from "../plugins/apicon";
import Statusguia from "../components/Statusguia.vue";
import Printfactura from "../components/Printfactura.vue";
import Printreceiptdhl from "../components/Printreceiptdhl.vue";
import Printguia from '../components/Printguia.vue';
import Cotizacion from "../components/Cotizacion.vue";
import Vistaguia from '../components/Vistaguia.vue';
import Enviardhl from "../components/EnviarDHL.vue";
import Envioups from "../components/EnviarUPS.vue";
import EnviarFedex from "../components/EnviarFedex.vue";
import Pickupdhl from "../components/PickupDHL.vue";
import Pickupups from "../components/PickupUPS.vue";
import PickupFedEx from "../components/PickupFedEx.vue";
import Pickupnacional from "../components/PickupNacional.vue";
import Agregaragente from "../components/Agregaragente.vue";
import Asignarcliente from "../components/AsignarCliente.vue";
import Asignarundel from "../components/AsignarUndel.vue";
import Asignarseguro from "../components/AsignarSeguro.vue";
import Asignarcargosadicionales from "../components/AsignarCargosAdicionales.vue";
import Informacionadicional from "../components/InformacionAdicional.vue";
import Mailtemplate from "../views/MailTemplate.vue";
import Repesaje from "../components/Repesaje.vue";
import Reclamos from "../components/Reclamos.vue";
import Cargarimagenpod from "../components/Cargarimagenpod.vue";
import Guia from "../components/Guia.vue";
import EnviarTramaco from '../components/EnviarTramaco.vue';
import EnviarServiEntrega from "../components/EnviarServiEntrega.vue";

import utils from "../utils/utils";
import apiServiEntrega from '../plugins/apiServiEntrega';
export default {
  components: {
    Statusguia,
    Printfactura,
    Printreceiptdhl,
    Printguia,
    Cotizacion,
    Vistaguia,
    Enviardhl,
    Envioups,
    EnviarFedex,
    Pickupdhl,
    Pickupups,
    PickupFedEx,
    Pickupnacional,
    Agregaragente,
    Asignarcliente,
    Asignarundel,
    Asignarseguro,
    Asignarcargosadicionales,
    Informacionadicional,
    Mailtemplate,
    Repesaje,
    Reclamos,
    Cargarimagenpod,
    Guia,
    EnviarTramaco,
    EnviarServiEntrega
  },
  data() {
    return {
      tipoguia: "",
      isCliente: true,
      id: null,
      datos: null,
      dlgOpciones: false,
      fullScreen: false,
      dialogSet: {
        nombre: null,
      },
      searcher: "",
      options: {},
      totalData: 0,
      guiasF: [],
      guias: [],
      filtro: [
        { tipo: "Importación", cod: "importacion" },
        { tipo: "Exportación", cod: "exportacion" },
        { tipo: "Nacional", cod: "nacional" },
      ],
      tipo: null,
      tFilter: null,
      headers: [
        {
          text: "Tipo",
          value: "tipoguia",
          align: "start",
          sortable: false,
        },
        { text: "Fecha", value: "created_at", sortable: false, formatter: (x) => x ? utils.formatDate(x) : null },
        { text: "Cuenta", value: "cuenta", sortable: false },
        { text: "# Guia", value: "guia_interna", sortable: false },
        { text: "Remitente", value: "empresa_e", sortable: false },
        { text: "Pais", value: "pais_e", sortable: false },
        { text: "Consignatario", value: "empresa_c", sortable: false },
        { text: "Pais", value: "pais_c", sortable: false },
        { text: "Agente", value: "proveedor", sortable: false },
        { text: "Guia Agente", value: "guia_proveedor", sortable: false },
        { text: "Recolecta Proveedor", value: "numrecolecta", sortable: false },
        { text: "PO", value: "po", sortable: false },
        { text: "Creado por", value: "usuario.name", sortable: false },
        { text: "Acciones", align: "end", value: "acciones", sortable: false },
      ],
      headersCli: [
        {
          text: "Tipo",
          value: "tipoguia",
          align: "start",
          sortable: false,
        },
        { text: "Fecha", value: "created_at", sortable: false, formatter: (x) => x ? utils.formatDate(x) : null },
        { text: "Cuenta", value: "cuenta", sortable: false },
        { text: "# Guia", value: "guia_interna", sortable: false },
        { text: "Guia Agente", value: "guia_proveedor", sortable: false },
        { text: "PO", value: "po", sortable: false },
        { text: "Remitente", value: "empresa_e", sortable: false },
        { text: "Pais", value: "pais_e", sortable: false },
        { text: "Consignatario", value: "empresa_c", sortable: false },
        { text: "Pais", value: "pais_c", sortable: false },
        { text: "Creado por", value: "usuario.name", sortable: false },
        { text: "Acciones", align: "end", value: "acciones", sortable: false },
      ],
      guiasTransmitir: [],
    };
  },
  watch: {
    dlgOpciones: function(newVal, old){
      if(!newVal){
        this.cerrarModal();
      }
    },
    tipo: function (item) {
      if (item) {
        this.tFilter = item.cod;
      } else {
        this.tFilter = null;
      }
      this.getData();
    },
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },
  created: function () {},
  mounted: function () {
    apicon.setAuthHeaders();
    this.isCliente = localStorage.getItem('cliente');
    // this.getData();
  },
  methods: {
    //Metodo para crearGuia:
    crearGuia: async function(tipoG) {
      this.fullScreen = true;
      //setear el objeto del dialog(s)
      this.dialogSet.nombre = 'guia';
      //setear el objeto del dialog(s)
      this.datos = null;
      if(tipoG == "I"){
        this.tipoguia = "IMPORTACION";
        this.codtipoguia = tipoG;
      }else if(tipoG == "E"){
        this.tipoguia = "EXPORTACION"
        this.codtipoguia = tipoG;
      }else if(tipoG == "N"){
        this.tipoguia = "NACIONAL"
        this.codtipoguia = tipoG;
      }
      this.dlgOpciones = true;
    },
     //Metodo para editar Guia
    edtGuia: async function(item){
      this.fullScreen = true;
      //setear el objeto del dialog(s)
      this.dialogSet.nombre = 'guia';
      //setear el objeto del dialog(s)
      this.datos = null;
      this.datos = item;
      this.id = null
      this.id = item.id;
      if(item.tipoguia == "importacion"){
        this.tipoguia = "IMPORTACION";
        this.codtipoguia = "I";
      }
      else if(item.tipoguia == "exportacion"){
        this.tipoguia = "EXPORTACION";
        this.codtipoguia = "E";
      }
      else if(item.tipoguia == "nacional"){
        this.tipoguia = "NACIONAL"
        this.codtipoguia = "N";
      }
      this.dlgOpciones = true;
    },
    getData: async function () {
      const { page, itemsPerPage } = this.options;
      await apicon
        .getDataApi(
          apicon.getApiBaseUrl() +
            "guias?page=" +
            page +
            "&per_page=" +
            itemsPerPage +
            (this.searcher != null ? "&search=" + this.searcher : "") +
            (this.tFilter != null ? "&tipo=" + this.tFilter : "")
        )
        .then((result) => {
          this.guiasF = result.data;
          this.guias = result.data;
          // this.filter();
          // El total de item
          this.totalData = result.total;
        });
    },
    cerrarModal: function () {
      if(this.dlgOpciones){
        this.dlgOpciones = false;
      }
      this.getData();
      this.dialogSet.nombre = "";
      this.id = null;
    },
    showModalEstatus: async function (item) {
      this.fullScreen = false;
      this.dialogSet.nombre = "estatusGuia";
      this.datos = item;
      this.id = item.id;
      this.dlgOpciones = true;
    },
    showModalPrintF: async function (item) {
      this.fullScreen = false;
      // setear el objeto del dialog(s)
      this.dialogSet.nombre = "printFactura";
      // setear el objeto del dialog(s)
      this.id = null;
      this.datos = null;
      this.datos = item;
      this.id = item.id;
      this.dlgOpciones = true;
    },
    showModalPrintGuia: function(item){
      this.fullScreen = false;
      // setear el objeto del dialog(s)
      this.dialogSet.nombre = "printGuia";
      // setear el objeto del dialog(s)
      this.id = null;
      this.datos = null;
      this.datos = item;
      this.id = item.id;
      this.dlgOpciones = true;
    },
    showModalCotizacion: function(item){
      this.fullScreen = true;
      // setear el objeto del dialog(s)
      this.dialogSet.nombre = "cotizacion";
      // setear el objeto del dialog(s)
      this.id = null;
      this.datos = null;
      this.datos = item;
      this.id = item.id;
      this.dlgOpciones = true;
    },
    duplicarGuia: function(item){
      let dswalConfirmar = {
          title: 'Consulta',
          text: 'Desea generar una nueva guia a partir de la seleccionada?',
          icon: 'question',
          showCancelButton: true
        }
      var self = this;
      this.$swal(dswalConfirmar).then((resultdlg) => {
          if (resultdlg.value) {
            apicon.saveDataApi(apicon.getApiBaseUrl() + 'duplicarguia/' + item.id,null).then((result) => {
              if(result.status){
                this.$swal('Guia creada : ' + result.data.guia_interna);
                self.getData();
              }
            })
          }

        });

    },
    showModalEnvCorreo: function(item){
      this.fullScreen = true;
      // setear el objeto del dialog(s)
      this.dialogSet.nombre = "envCorreo";
      // setear el objeto del dialog(s)
      this.id = null;
      this.datos = null;
      this.datos = item;
      this.id = item.id;
      this.dlgOpciones = true;
    },
    showModalVistaGuia: function(item){
      this.fullScreen = false;
      // setear el objeto del dialog(s)
      this.dialogSet.nombre = "vistaGuia";
      // setear el objeto del dialog(s)
      this.id = null;
      this.datos = null;
      this.datos = item;
      this.id = item.id;
      this.dlgOpciones = true;
    },
    showModalPrintReceiptDhl: async function (item) {
      this.fullScreen = false;
      // setear el objeto del dialog(s)
      this.dialogSet.nombre = "printReceiptDhl";
      // setear el objeto del dialog(s)
      this.id = null;
      this.datos = null;
      this.datos = item;
      this.id = item.id;
      this.dlgOpciones = true;
    },
    showModalEnvDHL: async function (item) {
      this.fullScreen = false;
      //setear el objeto del dialog(s)
      this.dialogSet.nombre = "envDHL";
      //setear el objeto del dialog(s)
      this.datos = item;
      this.id = item.id;
      this.dlgOpciones = true;
    },
    showModalEnvFedEx: async function (item) {
      this.fullScreen = false;
      //setear el objeto del dialog(s)
      this.dialogSet.nombre = "envFedEx";
      //setear el objeto del dialog(s)
      this.datos = item;
      this.id = item.id;
      this.dlgOpciones = true;
    },
    showModalPickDHL: async function (item) {
      this.fullScreen = false;
      //setear el objeto del dialog(s)
      this.dialogSet.nombre = "pickDHL";
      //setear el objeto del dialog(s)
      this.datos = item;
      this.id = item.id;
      this.dlgOpciones = true;
    },
    showModalEnvUPS: async function (item) {
      this.fullScreen = false;
      //setear el objeto del dialog(s)
      this.dialogSet.nombre = "envUPS";
      //setear el objeto del dialog(s)
      this.datos = item;
      this.id = item.id;
      this.dlgOpciones = true;
    },
    showModalPickUPS: async function (item) {
      this.fullScreen = false;
      //setear el objeto del dialog(s)
      this.dialogSet.nombre = "pickUPS";
      //setear el objeto del dialog(s)
      this.datos = item;
      this.id = item.id;
      this.dlgOpciones = true;
    },
    showModalPickFedex: async function (item) {
      this.fullScreen = false;
      //setear el objeto del dialog(s)
      this.dialogSet.nombre = "pickFedEx";
      //setear el objeto del dialog(s)
      this.datos = item;
      this.id = item.id;
      this.dlgOpciones = true;
    },
    showModalEnvTramaco: function(item){
        this.fullScreen = false;
        //setear el objeto del dialog(s)
        this.dialogSet.nombre = "envtramaco";
        //setear el objeto del dialog(s)
        this.guiasTransmitir.push({
          id_guia : item.id
        })
        this.datos = item;
        this.id = item.id;
        this.dlgOpciones = true;
      },
      showModalEnvServ: function(item){
        this.fullScreen = false;
        //setear el objeto del dialog(s)
        this.dialogSet.nombre = "envserv";
        //setear el objeto del dialog(s)
        this.guiasTransmitir.push({
          id_guia : item.id
        })
        this.datos = item;
        this.id = item.id;
        this.dlgOpciones = true;
      },
      imprimirGuiaTramaco: function(item){
        apicon.downloadDataApi(apicon.getApiBaseUrl() + 'imprimirpdftramaco/' + item.guia_proveedor).then((result) => {
          utils.forceFileDownload(result,'.pdf',true,"Tramaco_Guia_" + item.guia_interna,"application/pdf")
        })
      },
      imprimirGuiaServiE: function(item){
        apicon.getDataApi(apicon.getApiBaseUrl() + 'imprimirguiaservie/' + item.guia_proveedor).then((result) => {
          const bytesData = utils.convertBase64toBytes(result.archivoEncriptado);
          utils.forceFileDownload(bytesData,'.pdf',true,"ServiEntrega_Guia_" + item.guia_interna,"application/pdf")
        });
        //apiServiEntrega.imprimirGuia(item.guia_agente);
        //apiServiEntrega.imprimirGuia(21177);
      },
      generarRotulosServiE: function(item){
        apicon.getDataApi(apicon.getApiBaseUrl() + 'imprimirrotulosservie/' +item.guia_proveedor).then((result) => {
          const bytesData = utils.convertBase64toBytes(result.archivoEncriptado);
          utils.forceFileDownload(bytesData,'.pdf',true,"ServiEntrega_Rotulos_" + item.guia_hija,"application/pdf")
        })
        //apiServiEntrega.generarRotulos(item.guia_agente);
      },
      generarStickersServiE: function(item){
        apiServiEntrega.generarStickers(item.guia_proveedor);
      },
    showModalPickNacional: function (item) {
      this.fullScreen = false;
      //setear el objeto del dialog(s)
      this.dialogSet.nombre  = "pickNac";
      //setear el objeto del dialog(s)
      this.datos = item;
      this.id = item.id;
      this.dlgOpciones = true;
    },
    showModalAddAgente: function (item) {
      this.fullScreen = false;
      //setear el objeto del dialog(s)
      this.dialogSet.nombre = "addAgente";
      //setear el objeto del dialog(s)
      this.datos = item;
      this.id = item.id;
      this.dlgOpciones = true;
    },
    showModalAddCliente: function(item){
      this.fullScreen = false;
      //setear el objeto del dialog(s)
      this.dialogSet.nombre = "addCliente";
      //setear el objeto del dialog(s)
      this.datos = item;
      this.id = item.id;
      this.dlgOpciones = true;
    },
    showModalAddUndel: function(item){
      this.fullScreen = true;
      //setear el objeto del dialog(s)
      this.dialogSet.nombre = "addUndel";
      //setear el objeto del dialog(s)
      this.datos = item;
      this.id = item.id;
      this.dlgOpciones = true;
    },
    showModalAddSeguro: function(item){
      this.fullScreen = false;
      //setear el objeto del dialog(s)
      this.dialogSet.nombre = "addSeguro";
      //setear el objeto del dialog(s)
      this.datos = item;
      this.id = item.id;
      this.dlgOpciones = true;
    },
    showModalAddCargos: function(item){
      this.fullScreen = false;
      //setear el objeto del dialog(s)
      this.dialogSet.nombre = "addCargos";
      //setear el objeto del dialog(s)
      this.datos = item;
      this.id = item.id;
      this.dlgOpciones = true;
    },
    showModalAddInfoAdic: function(item){
      this.fullScreen = false;
      //setear el objeto del dialog(s)
      this.dialogSet.nombre = "addInfoAdic";
      //setear el objeto del dialog(s)
      this.datos = item;
      this.id = item.id;
      this.dlgOpciones = true;
    },
    showModalAddReclamos: function(item){
      this.fullScreen = true;
      //setear el objeto del dialog(s)
      this.dialogSet.nombre = "reclamos";
      //setear el objeto del dialog(s)
      this.datos = item;
      this.id = item.id;
      this.dlgOpciones = true;
    },
    showModalAddRepesaje: function(item){
      this.fullScreen = true;
      //setear el objeto del dialog(s)
      this.dialogSet.nombre = "repesaje";
      //setear el objeto del dialog(s)
      this.datos = item;
      this.id = item.id;
      this.dlgOpciones = true;
    },
    showModalImagenPod: function (item) {
      this.fullScreen = false;
      //setear el objeto del dialog(s)
      this.dialogSet.nombre = "imgPOD";
      //setear el objeto del dialog(s)
      this.datos = item;
      this.id = item.id;
      this.dlgOpciones = true;
    },
    descargarLabelsDHL: function (item, descargar = false) {
      apicon
        .downloadDataApi(apicon.getApiBaseUrl() + "downlabelsdhl", {
          id: item.id,
        })
        .then((result) => {
          utils.forceFileDownload(
            result,
            ".pdf",
            !descargar,
            "AWB_" + item.guia_proveedor,
            "application/pdf"
          );
        });
    },
    descargarLabelsFedex: function(item){
      const url = item.url_label_fedex;
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.setAttribute('download', item.guia_proveedor + ".pdf")
      document.body.appendChild(link)
      link.click()
    },
    descargarFacturaDHL: function (item, descargar = false) {
      apicon
        .downloadDataApi(apicon.getApiBaseUrl() + "downfacturadhl", {
          id: item.id,
        })
        .then((result) => {
          utils.forceFileDownload(
            result,
            ".pdf",
            !descargar,
            "Invoice_" + item.guia_proveedor,
            "application/pdf"
          );
        });
    },
    descargarLabelsUPS: function (item) {
      apicon
        .downloadDataApi(apicon.getApiBaseUrl() + "downlabelsups", {
          id: item.id,
        })
        .then((result) => {
          //Verificar las piezas para descargar como gif o como zip
          if (item.piezas == 1) {
            utils.forceFileDownload(
              result,
              ".gif",
              true,
              "UPS_" + item.guia_proveedor,
              "image/gif"
            );
          } else {
            utils.forceFileDownload(
              result,
              ".zip",
              false,
              "UPS_" + item.guia_proveedor,
              ""
            );
          }
        });
    },
    revertirEnvio: function(item){
      var self = this;
      this.$swal({
        title: 'Alerta',
        text: 'Desea revertir este envio?... Asegurese de gestionar con su Agente la cancelacion del mismo.',
        icon: 'warning',
        showCancelButton: true}).then((resultdlg) => {
          if(resultdlg.value){
            apicon.saveDataApi(apicon.getApiBaseUrl() + 'revertirenvioprov', {id_guia : item.id})
            .then((result) => {
              self.getData();
              this.$swal(result.message);
            });
          }
        });
    },
    handleChangeSearch: function () {
      if (this.searcher == null || this.searcher == "") {
        this.getData();
      }
    },
    deleteItem: function (item) {
      var self = this;
      this.$swal(this.dswalEliminar).then((resultdlg) => {
        if (resultdlg.value) {
          apicon
            .deleteDataApi(apicon.getApiBaseUrl() + "guias/" + item.id)
            .then((result) => {
              self.getData();
              this.$swal(result.message);
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.v-data-table.v-data-table.v-data-table >>> td {
  font-size: 0.8rem !important;
  padding: 4px;
}
.v-data-table.v-data-table.v-data-table >>> th {
  font-size: 0.8rem !important;
  padding: 4px;
}
</style>
